import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import useCurrentMenu from 'common/hooks/useCurrentMenu'
import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import ThemeManager from 'theming/ThemeManager'

const PageTitle = ({ customTitle, customSubtitle }) => {
  const location = useLocation()
  const { actualMatch, currentMenu } = useCurrentMenu()
  const Theme = new ThemeManager()
  const [textH1, setTextH1] = useState('')
  const [textH2, setTextH2] = useState('')

  const h1Text = useMemo(() => {
    return customTitle || actualMatch?.nombre || currentMenu?.nombre || ''
  }, [actualMatch?.nombre, currentMenu?.nombre, customTitle])

  const h2Text = useMemo(() => {
    const solicitud = location?.state?.solicitud
    if (solicitud)
      return `${solicitud.codigo_solicitud ? solicitud.codigo_solicitud + ' - ' : ''}${solicitud.descripcion ?? solicitud.d_tipo ?? ''}`
    return actualMatch?.nombre
  }, [actualMatch?.nombre, location])

  const hideH2 = useMemo(() => {
    const exludeProgram = Theme.options?.pageTitleOptions?.excludeActualMatchElements.includes(
      actualMatch?.programa,
    )
    const parentSame = currentMenu?.nombre === actualMatch?.nombre

    return exludeProgram || parentSame || !textH2 || !location?.state?.solicitud
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actualMatch, currentMenu, textH2])

  useEffect(() => {
    if (h1Text) {
      setTextH1(h1Text)
    }
    if (h2Text) {
      setTextH2(h2Text)
    }
  }, [h1Text, h2Text])

  return actualMatch?.nombre || currentMenu?.nombre ? (
    <Box
      className="page-title-box"
      sx={{
        display: Theme.options?.pageTitleOptions?.excludeElements?.includes(actualMatch?.programa)
          ? 'none'
          : 'flex',
        alignItems: 'baseline',
        flexWrap: 'wrap',
        gap: 2,
        my: 4,
      }}
    >
      <Typography variant="h1">{textH1}</Typography>
      <Typography
        variant="h2"
        sx={{
          display: hideH2 ? 'none' : 'flex',
        }}
      >
        {textH2}
      </Typography>
    </Box>
  ) : (
    <></>
  )
}

export default PageTitle
